const isUserAuthenticated = () =>{
    const userLogin = localStorage.getItem("token");
    if(userLogin){
        return true;
    }
    return false;
}

export default isUserAuthenticated;